import { AvailableIcon } from '../types/map';
import RaceTrackPointView from '../types/view/RaceTrackPointView';
import { SuppliesEnum } from '../types/enum/SuppliesEnum';

export const getPointIcons = ({
    supplies,
    hasRest,
    hasToilets,
    hasShower,
    hasBus,
    hasMedical,
    hasBag,
    hasPower,
    hasNaak,
}: RaceTrackPointView): AvailableIcon[] => {
    const icons: AvailableIcon[] = [];

    if (supplies === SuppliesEnum.HOT_FOOD) {
        icons.push('hotFood');
    }

    if (supplies === SuppliesEnum.FOOD) {
        icons.push('food');
    }

    if (supplies === SuppliesEnum.DRINK) {
        icons.push('drink');
    }

    if (hasNaak) {
        icons.push('naak');
    }

    if (hasMedical) {
        icons.push('emergency');
    }

    if (hasRest) {
        icons.push('rest');
    }

    if (hasToilets) {
        icons.push('toilet');
    }

    if (hasBus) {
        icons.push('bus');
    }

    if (hasBag) {
        icons.push('bag');
    }

    if (hasShower) {
        icons.push('shower');
    }

    if (hasPower) {
        icons.push('power');
    }

    return icons;
};
